import { OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { INDRAMybService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';
import { INDRAAncillariesSelectionConfirmation } from '@ibe.models/ancillaries-selection.indra.model.lib';
import { getCurrencySymbol } from '@angular/common';
import { OnInit, EventEmitter } from '@angular/core';
import { INDRAOutbound } from '@ibe.models/outbound.indra.model.lib';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { ProductFieldObject } from '@ibe.models/google-analytics.indra.model';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';

import {
	MUSICAL_INSTRUMENT_ORDER,
	SSR_CODE_FIREARMS,
	SSR_CODE_SPORTS_SPORTING_EQUIPMENT,
	EXTRAS_ANCILLARY_MUSICAL,
	EXTRAS_ANCILLARY_SEAT,
	TRANSLATION_ANCILLARY_DETAILED,
	PAX_TYPES,
	EXTRAS_ANCILLARY_MEAL,
	SESSION_VAR_KEY_MARKET,
	EXTRAS_ANCILLARY_BAG,
	SESSION_VAR_KEY_CURRENCY,
	TAP_HEADER_MILES_AND_GO_MILES,
	TAP_HEADER_MILES_AND_GO_SILVER,
	TAP_HEADER_MILES_AND_GO_GOLD,
	TAP_HEADER_MILES_AND_GO_NAVIGATOR,
	EXTRAS_ANCILLARY_PREF_BOARD,
  EXTRAS_ANCILLARY_LOUNGE,
  EMD_TYPEC_ANCILLARIES
} from '@ibe.config';
import * as _ from 'lodash';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import { takeWhile } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { INDRAGoogleAnalyticsService, EVENT_ACTION_ADD_CART } from '@ibe.services/google.analytics.indra.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { BookedTrip } from '@ibe/models';
import { INDRATotalFlightPrice } from '@ibe.models/flight-price.model.indra.lib';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

export abstract class INDRAExtraSidebar implements OnInit, OnDestroy {
	private _flight: any;
	private _flightRouteInput: any;
	private _flightCardId: string;
	private _same: boolean;
	private _passengers: INDRAPax[] = [];

	private _paxAddOnFeatures = [];
	private _paxAddedFeature = []; // selected ancillaries
	private _paxDeletedFeatures: INDRAAddOnAncillary[] = []; // selected ancillaries that are deleted
	protected totalAddedItems: number;
	protected totalPrice: number;
	protected totalCurrency = '';
	protected hasCartItems = false;
	public isServiceLoading = false;
	protected selectionApiError = false;
	protected pnr: string;
	protected isReviewFlights: boolean = false;

	isLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();

	protected shoppingCartContent: any;
	hasAppliedToAllFlights: boolean = false;
	payWithMiles: boolean = false;

	checkAlive: boolean = true;

	milesSpent$: Observable<number> = this.store.select(fromStore.getTotalMilesToSpend);
	milesSpent: number = 0;

	ancillaryTotalToPay$: Observable<any> = this.store.select(fromStore.getAncillaryTotalToPay);
	ancillariesTotalDiscount: number = 0;
	flightAncillaryDetails: any;
	_optionList = [];
	translationAncillaryDetailedKey = TRANSLATION_ANCILLARY_DETAILED;
	paymentTypeChanged: boolean = false;
	ancillaryToUpdate;
	ancillaryOnOtherFlightCard = [];

	userInfo$: Observable<Object> = this.store.select(fromStore.getUserInfo);
	userMiles: number;
	isUserLoggedIn: boolean;
	userTierLevel: string;

	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean;

	hasChanges$: Observable<any> = combineLatest(
		this.bookAwardFlights$
	);

	protected isAlive: boolean = true;
	closeSideBarFlag: boolean = false;
	savedRemainingMilesToPay: number;

	addedAncTotalMiles: number;
	tempShoppingCartContent: any;
	tempMilesNeeded: any;
	isBtnDoneClicked: boolean = false;

	limitNegativeFFLevelMiles: number;
	limitNegativeFFLevelSilver: number;
	limitNegativeFFLevelGold: number;
	limitNegativeFFLevelNavigator: number;

	protected constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected bookingService: INDRABookingService,
		protected mybService: INDRAMybService,
		protected ibeAdminService: INDRAIbeAdminService,
		protected ancillariesSelectionSrv: INDRAAncillariesSelectionService,
		protected ancillariesShoppingCartSrv: INDRAAncillariesShoppingCartService,
		protected ancillariesType: string,
		protected dateService: INDRADateService,
		protected googleAnalytics: INDRAGoogleAnalyticsService,
		protected storageService: INDRAStorageService,
		protected store: Store<fromStore.State>,
		protected currencyPipe: INDRACurrencyPipe,
		protected paymentInfoService: PaymentService,
	) {

		this.milesSpent$
			.pipe(takeWhile(() => this.checkAlive))
			.subscribe((value) => {
				if (value) {
					this.milesSpent = value;
				}
			});

		this.ancillaryTotalToPay$
			.pipe(takeWhile(() => this.checkAlive))
			.subscribe(value => {
				this.ancillariesTotalDiscount = value && value.miles ? value.miles : 0;
			});

		this.flightAncillaryDetails = this.storageService.get('INDRABFMDataStorageService._ancillariesPerFlight');

		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((user: any) => {
				if (user) {
					this.isUserLoggedIn = user;
					this.userTierLevel = user.ffLevel;
					this.userMiles = user && user['currentPoints'] ? user['currentPoints'] : 0;
				}
			});

		this.hasChanges$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(([bookAwardFlights]) => {
				this.bookAwardFlights = bookAwardFlights;
			});
	}

	// ACCESSORS

	get flight(): INDRAOutbound { return this._flight; }
	set flight(value: INDRAOutbound) { this._flight = value; }

	get flightCardId(): string { return this._flightCardId; }
	set flightCardId(value: string) { this._flightCardId = value; }

	get same(): boolean { return this._same; }
	set same(value: boolean) { this._same = value; }

	get passengers(): INDRAPax[] { return this._passengers; }
	set passengers(value: INDRAPax[]) { this._passengers = value; }

	get paxAddedFeature(): any[] { return this._paxAddedFeature; }
	set paxAddedFeature(value: any[]) { this._paxAddedFeature = value; }

	get paxAddOnFeatures(): any[] { return this._paxAddOnFeatures; }
	set paxAddOnFeatures(value: any[]) { this._paxAddOnFeatures = value; }

	get paxDeletedFeatures(): any[] { return this._paxDeletedFeatures; }
	set paxDeletedFeatures(value: any[]) { this._paxDeletedFeatures = value; }

	get flightRouteInput(): INDRAOutbound { return this._flightRouteInput; }
	set flightRouteInput(value: INDRAOutbound) { this._flightRouteInput = value; }

	get optionList(): any[] { return this._optionList; }
	set optionList(value: any[]) { this._optionList = value; }


	ngOnInit() {
		this.limitNegativeFFLevelMiles = this.ancillariesSelectionSrv.limitNegativeFFLevelMiles
		this.limitNegativeFFLevelSilver = this.ancillariesSelectionSrv.limitNegativeFFLevelSilver
		this.limitNegativeFFLevelGold = this.ancillariesSelectionSrv.limitNegativeFFLevelGold
		this.limitNegativeFFLevelNavigator = this.ancillariesSelectionSrv.limitNegativeFFLevelNavigator

		if (this.router.url.includes('/review-your-trip')) this.isReviewFlights = true;

		// Get URL parameters
		this.pnr = this.bookingService.getCurrentPNR();

		const addedAncillariesAllFlights = this.INDRA_getAllAddedAncillaries(true);
		const addedAncillaries = addedAncillariesAllFlights.filter(item => item.flightCardId === this.flightCardId);
		this.totalAddedItems = addedAncillaries.length;
		this.totalPrice = addedAncillaries.reduce((sum, f) => (sum += parseFloat(f.price)), 0);
		// Checks if this flightCard is already loaded
		if (!this.paxAddOnFeatures[this.flightCardId]) {
			// Added item.code != 'WEAP' && item.code != 'SPEQ', to filter firearms and sports equipment
			// Temp due to IBETPIUNO-7147
			this.paxAddOnFeatures[this.flightCardId] = this.bookingService.INDRA_getAddOnAncillaries(this.ancillariesType, this.flight.idFlight.toString(), this.flightCardId)
				.filter(item => item.code != SSR_CODE_FIREARMS && item.code != SSR_CODE_SPORTS_SPORTING_EQUIPMENT);
		}

		// Check that cart ancillaries are not already added or deleted
		if (addedAncillariesAllFlights.findIndex(item => item.ssrTatto != undefined && item.flightCardId === this.flightCardId) < 0
			&& this.paxDeletedFeatures.findIndex(item => item.ssrTatto != undefined && item.flightCardId === this.flightCardId) < 0) {
			const cartAddedAncillaries: INDRAAddOnAncillary[] = this.ancillariesShoppingCartSrv.INDRA_getAddedAncillariesByFlightCardId(this.ancillariesType, this.flightCardId);

			cartAddedAncillaries.forEach(item => {
				this.INDRA_handleAddAncillary(item);
			});
			if (cartAddedAncillaries.length > 0) this.hasCartItems = true;
		}

		this.ancillariesShoppingCartSrv.INDRA_getAncillariesShoppingCart(this.pnr).subscribe(result => {
			this.shoppingCartContent = result;
		});

		this.sidebarService.sidebarClosed$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			if (value) {
				if (!this.isBtnDoneClicked) {
					this.ancillariesSelectionSrv.payWithMilesFlightList = this.storageService.get('prevPayWithMilesFlightList');
				}
				else {
					this.ancillariesSelectionSrv.INDRA_getPayWithMilesByFlightId(this.flightCardId, this.payWithMiles, this.ancillariesType);
					this.storageService.set('prevPayWithMilesFlightList', this.ancillariesSelectionSrv.payWithMilesFlightList)
				}
			}
		});


		this.INDRA_validateFlightPayWithMilesStatus();
	}

	ngOnDestroy() {
		this.isAlive = false;
	}


	INDRA_validateFlightPayWithMilesStatus() {
		//VALIDATION: CHECK THE PREVIOUS "PAY WITH MILES" STATUS FROM THE STORED "prevPayWithMilesFlightList" AND CHECK IF IT EXISTS IN "this.shoppingCartContent.itemsAdded"  
		let prevPayWithMilesFlightList = this.storageService.get('prevPayWithMilesFlightList');

		if (prevPayWithMilesFlightList && prevPayWithMilesFlightList.length > 0) {
			prevPayWithMilesFlightList.map(data => {
				if (this.shoppingCartContent && this.shoppingCartContent.itemsAdded && this.shoppingCartContent.itemsAdded.length > 0) {
					let result = this.shoppingCartContent.itemsAdded.find(item => item.flightId == data.flightID && item.type == data.ancType);
					if (result === undefined) {
						data.isChecked = false;
					}
				}
			});
			this.ancillariesSelectionSrv.payWithMilesFlightList = prevPayWithMilesFlightList;
			this.payWithMiles = this.ancillariesSelectionSrv.INDRA_getFlightPayWithMilesStatus(this.flightCardId, this.ancillariesType);
		}
	}

	// ANCILLARIES MANAGEMENT
	INDRA_getInitialAddedExtras(type: string) {
		const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
		let hasAddedExtrasFlag: boolean = false;

		if (shoppingCartItems.itemsAdded && shoppingCartItems.itemsAdded.length > 0) {
			shoppingCartItems.itemsAdded.map(data => {
				if (data.type == type) {
					hasAddedExtrasFlag = true;
				}
			});
		}

		return hasAddedExtrasFlag;
	}


	INDRA_handleAddAncillary(addedItem: INDRAAddOnAncillary) {
		// if (this.bookAwardFlights && this.payWithMiles) {
		// 	this.tempShoppingCartContent = null;
		// }

		const index = this.paxAddedFeature.findIndex(
			item => Object.keys(item)[0] === addedItem.paxId.toString()
		);

		const newAddedItem = Object.assign({}, addedItem);

		if (index >= 0) {
			this.paxAddedFeature[index][addedItem.paxId].push(newAddedItem);
		} else {
			this.paxAddedFeature.push({
				[addedItem.paxId]: [newAddedItem]
			});
		}

		// For flight-based ancillaries we add it for all the segments (if not already added)
		if (addedItem.flightBased === true && this.flight.listSegment.length > 1 && addedItem.flightBasedAddOns.length === 0) {
			this.flight.listSegment.filter(seg => seg.idInfoSegment != addedItem.segmentId).forEach(
				seg => {
					const newAddedSegItem: INDRAAddOnAncillary = Object.assign({}, addedItem, { flightBasedAddOns: undefined });
					newAddedSegItem.segmentId = seg.idInfoSegment;
					newAddedSegItem.price = 0;
					addedItem.flightBasedAddOns.push(newAddedSegItem);
				}
			);
		}

		if (addedItem.maxQuantity == this.INDRA_countAddedAncillariesForPassenger(addedItem)) {
			this.INDRA_disableAddOnFeature(addedItem);
		}

		this.totalAddedItems++;
		this.totalCurrency = this.INDRA_getCurrencySymbol(addedItem.currency);
		this.totalPrice = this.totalPrice + parseFloat(addedItem.price.toString());

		if (this.totalAddedItems > 0) {
			return true;
		} else return false;
	}

	INDRA_handleRemoveAncillary(removedItem: INDRAAddOnAncillary) {
		let index2;
		if (removedItem.ssrTatto != undefined) {
			this.paxDeletedFeatures.push(removedItem);
		}

		const index = this.paxAddedFeature.findIndex(
			item => Object.keys(item)[0] === removedItem.paxId.toString()
		);

		if (EMD_TYPEC_ANCILLARIES.includes(this.ancillariesType)) {
			index2 = this.paxAddedFeature[index][removedItem.paxId].findIndex(
				item => (item.flightCardId === this.flightCardId && item.code === removedItem.code && item.price === removedItem.price &&
					(!item.value || item.value === removedItem.value) && item.segmentId === removedItem.segmentId)
			);
		} else {
			index2 = this.paxAddedFeature[index][removedItem.paxId].findIndex(
				item => (item.flightCardId === this.flightCardId && item.code === removedItem.code && item.price === removedItem.price &&
					(!item.value || item.value === removedItem.value))
			);
		}

		this.paxAddedFeature[index][removedItem.paxId].splice(index2, 1);
		this.INDRA_enableAddOnFeature(removedItem);

		this.totalAddedItems--;

		if (this.bookAwardFlights) {
			this.tempShoppingCartContent = this.tempShoppingCartContent ? this.tempShoppingCartContent : _.cloneDeep(this.shoppingCartContent);
			if (this.tempShoppingCartContent && this.tempShoppingCartContent.itemsAdded.length > 0) {
				let removeFlag = false;
				this.tempShoppingCartContent.itemsAdded.map((data, index) => {
					if (!removeFlag && data.ssrTatto === removedItem.ssrTatto) {
						this.tempShoppingCartContent.itemsAdded.splice(index, 1);
						removeFlag = true;
					}
				});
				this.tempShoppingCartContent.numItems = this.tempShoppingCartContent.itemsAdded.length;
			}
		}


		this.totalPrice = this.totalPrice - parseFloat(removedItem.price.toString());
		this.INDRA_registerGARemoveAncillaryFromCart(removedItem);



		if (this.totalAddedItems > 0) {
			return true;
		} else {
			// this.payAncillariesWithMilesService.INDRA_getPayWithMilesByFlightId(this.flightCardId, false, removedItem.type);
			return false
		};
	}

	/**
	* Handle remove ancillary for segmented ancillary sidebars.
	* @param {INDRAAddOnAncillary} removedItem ancillary to be removed
	* @param {number} segmentId ancillary will be removed for this segment
	*/
	INDRA_handleRemoveSegmentAncillary(removedItem: INDRAAddOnAncillary, segmentId: number) {

		const index = this.paxAddedFeature.findIndex(
			item => Object.keys(item)[0] === removedItem.paxId.toString()
		);

		// ssrTatto doesn't need to be checked for deleting of seats 
		if (removedItem.ssrTatto != undefined || removedItem.type === EXTRAS_ANCILLARY_SEAT) {
			this.paxDeletedFeatures.push(removedItem);
		}

		if (index > -1) {
			const index2 = this.paxAddedFeature[index][removedItem.paxId].findIndex(
				item => (item.flightCardId === this.flightCardId && item.code === removedItem.code
					&& item.price === removedItem.price && item.segmentId === segmentId)
			);

			this.paxAddedFeature[index][removedItem.paxId].splice(index2, 1);
			this.INDRA_enableAddOnFeature(removedItem);

			this.totalAddedItems--;
			this.totalPrice = this.totalPrice - parseFloat(removedItem.price.toString());
		}

	}

	INDRA_hasAddedAncillaries() {
		if (this.hasAppliedToAllFlights) {
			return true;
		} else {
			return (this.totalAddedItems > 0 || this.hasCartItems);
		}
	}

	INDRA_checkAddedAncillariesForPassenger(idPax: number) {
		let flag = false;
		const index = this.paxAddedFeature.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (this.paxAddedFeature) {
			const paxAddedFeature = this.paxAddedFeature[index];
			if (paxAddedFeature) {
				if (paxAddedFeature[idPax] && paxAddedFeature[idPax].filter(item => item.flightCardId === this.flightCardId).length > 0) {
					flag = true;
				}
			}
		}
		return flag;
	}

	INDRA_getAddedAncillariesForPassenger(idPax: number) {
		let returnValue: INDRAAddOnAncillary[] = [];

		const index = this.paxAddedFeature.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);


		if (index >= 0) {
			returnValue = this.paxAddedFeature[index][idPax].filter(item => item.flightCardId === this.flightCardId);
		}

		if (EMD_TYPEC_ANCILLARIES.includes(this.ancillariesType)) {
			//METHOD: SET THE enabled PROPERTY TO TRUE IN ORDER TO ADD THE ANCILLARY TO THE TOTAL COUNT (PREFERRED BOARDING)
			if (returnValue && returnValue.length > 0) {
				returnValue.map(data => {
					this.INDRA_enableAddOnFeature(data)
				});
			}
		}

		return returnValue;
	}

	/**
	* Gathers added ancillaries for passenger on the segment.
	* @param {number} idPax pax id of the passenger
	* @param {number} segmentId segment id of the stop
	*/
	INDRA_getAddedAncillariesForPassengerSegment(idPax: number, segmentId: number) {
		let returnValue: INDRAAddOnAncillary[] = [];

		const index = this.paxAddedFeature.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);

		if (index >= 0) {
			// tslint:disable-next-line:radix
			returnValue = this.paxAddedFeature[index][idPax].filter(item => item.flightCardId === this.flightCardId && parseInt(item.segmentId) === segmentId);
		}

		return returnValue;

	}

	protected INDRA_countAddedAncillariesForPassenger(addedItem: INDRAAddOnAncillary) {
		let returnValue = 0;

		const index = this.paxAddedFeature.findIndex(
			item => Object.keys(item)[0] === addedItem.paxId.toString()
		);

		if (index >= 0) {
			const paxFeatures: INDRAAddOnAncillary[] = this.paxAddedFeature[index][addedItem.paxId];
			paxFeatures.forEach(
				item => {
					if (item.flightCardId === this.flightCardId &&
						item.code === addedItem.code && item.price === addedItem.price &&
						(!item.value || item.value === addedItem.value)) returnValue++;
				}
			);
		}

		return returnValue;
	}

	INDRA_getAddOnForPassenger(idPax: number): INDRAAddOnAncillary[] {
		let returnValue: INDRAAddOnAncillary[] = [];
		const index = this.paxAddOnFeatures[this.flightCardId].findIndex(
			item => {
				let arrObj = item[Object.keys(item)[0]];
				if (arrObj.length > 0) {
					return arrObj[0].paxId === idPax;
				}
			}
		);

		if (index > -1) {
			let paxAddOnFeature = this.paxAddOnFeatures[this.flightCardId][index];
			if (paxAddOnFeature[idPax].length > 0) {
		    if (EMD_TYPEC_ANCILLARIES.includes(this.ancillariesType)) {
					//METHOD: SORT THE ARRAY BY segmentId IN ORDER TO DISPLAY THE FIRST SEGMENT'S PRICE 
					paxAddOnFeature[idPax] = paxAddOnFeature[idPax].sort((a, b) => (a.segmentId < b.segmentId ? -1 : 1))
					returnValue = paxAddOnFeature[idPax];
					return returnValue;
				}
				// Workarround to filter info to the first found segment
				const firstSegment = paxAddOnFeature[idPax][0].segmentId;

				returnValue = paxAddOnFeature[idPax].filter(item => item.enabled == true && item.segmentId == firstSegment);
				if (this.ancillariesType === EXTRAS_ANCILLARY_MUSICAL)
					returnValue = this.sortByArray(returnValue, MUSICAL_INSTRUMENT_ORDER, 'code');
			}
		}


		return returnValue;
	}

	sortByArray(array, order, key) {
		array.sort(function (a, b) {
			const A = a[key], B = b[key];

			if (order.indexOf(A) > order.indexOf(B)) {
				return 1;
			} else {
				return -1;
			}

		});
		return array;
	}


	/**
	* Gathers available add ons for passenger and its flight segment.
	* @param {number} idPax pax id of the passenger
	* @param {number} segmentId segment id of the stop
	* @param {string} paxType passenger type
	*/
	INDRA_getAddOnForPassengerSegment(idPax: number, segmentId: string): INDRAAddOnAncillary[] {
		let returnValue: INDRAAddOnAncillary[] = [];
		if (this.paxAddOnFeatures.length <= 0) {
			return;
		}
		const index = this.paxAddOnFeatures[this.flightCardId].findIndex(
			item => {
				if (item[Object.keys(item)[0]].length > 0)
					return item[Object.keys(item)[0]][0].paxId === idPax;
			}
		);

		if (index > -1) {
			const paxAddOnFeature = this.paxAddOnFeatures[this.flightCardId][index];
			if (paxAddOnFeature) {
				const paxAddOnFeatureValue = paxAddOnFeature[idPax];
				if (paxAddOnFeatureValue) {
					if (this.ancillariesType == EXTRAS_ANCILLARY_MEAL) {
						returnValue = paxAddOnFeatureValue.filter(item => item.segmentId == segmentId);
					} else {
						returnValue = paxAddOnFeatureValue.filter(item => item.enabled == true && item.segmentId == segmentId);
					}
				}
			}
		}

		return returnValue;
	}


	private INDRA_disableAddOnFeature(addOnItem: INDRAAddOnAncillary) {
		const index = this.paxAddOnFeatures[this.flightCardId].findIndex(
			item => Object.keys(item)[0] === addOnItem.paxId.toString()
		);
		const index2 = this.paxAddOnFeatures[this.flightCardId][index][addOnItem.paxId].findIndex(
			item => (item.enabled == true && item.code === addOnItem.code && item.price === addOnItem.price &&
				(!item.value || item.value === addOnItem.value)) // added value for PETC / CAT & DOGS
		);

		if (index2 >= 0)
			this.paxAddOnFeatures[this.flightCardId][index][addOnItem.paxId][index2].enabled = false;
	}

	private INDRA_enableAddOnFeature(addOnItem: INDRAAddOnAncillary) {
		const index = this.paxAddOnFeatures[this.flightCardId].findIndex(
			item => Object.keys(item)[0] === addOnItem.paxId.toString()
		);
		const index2 = this.paxAddOnFeatures[this.flightCardId][index][addOnItem.paxId].findIndex(
			item => (item.enabled == false && item.code === addOnItem.code && item.price === addOnItem.price &&
				(!item.value || item.value === addOnItem.value)) // added value for PETC / CAT & DOGS)
		);

		if (index2 >= 0)
			this.paxAddOnFeatures[this.flightCardId][index][addOnItem.paxId][index2].enabled = true;
	}

	private INDRA_getAllAddedAncillaries(includeAddedFromCart: boolean): INDRAAddOnAncillary[] {
		const returnValue: INDRAAddOnAncillary[] = [];
		this.paxAddedFeature.forEach(item => {
			item[Object.keys(item)[0]].forEach(element => {
				if (includeAddedFromCart || element.ssrTatto == undefined)
					returnValue.push(element);
			});
		});
		return returnValue;
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
		this.closeSideBarFlag = false;
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.closeSidebar(); }

	INDRA_handleDone() {
		this.INDRA_handleAncillariesSelection();
	}

	INDRA_handleApplyAll() {
		let addedAncillaries: INDRAAddOnAncillary[] = this.INDRA_getAllAddedAncillaries(false);
		const addedAncillariesClone = _.cloneDeep(addedAncillaries);
		if (addedAncillaries.length == 0 && this.paxDeletedFeatures.length == 0) {
			this.isLoaded.emit(true);
		} else {
			// add ancillaries only
			if (addedAncillaries.length != 0 && this.paxDeletedFeatures.length == 0) {
				this.isServiceLoading = true;
				this.selectionApiError = false;
				if (this.ancillariesType == EXTRAS_ANCILLARY_BAG) {
					addedAncillaries = addedAncillaries.filter(item => item.flightCardId == this.flightCardId);
				} else {
					addedAncillaries = _.uniqBy(addedAncillaries, v => [v.code, v.paxTatto].join());
				}

				this.ancillaryOnOtherFlightCard = addedAncillariesClone.filter(item => item.flightCardId != this.flightCardId);

				this.INDRA_callApplyAllAPI(addedAncillaries);
				// remove and/or add ancillaries
			} else if (this.paxDeletedFeatures.length != 0) {

				const addedAncillariesInCart: INDRAAddOnAncillary[] = this.INDRA_getAllAddedAncillaries(true);

				this.isServiceLoading = true;
				this.selectionApiError = false;

				const deletedFeaturesCode = this.INDRA_getDeletedFeaturesCode();
				const deletedFeatures = [];
				let deleteOnly = false;

				if (this.paxDeletedFeatures.length != 0 && addedAncillaries.length == 0) {
					deleteOnly = true;
				}

				for (const i in this.paxDeletedFeatures) {
					for (const x in this.shoppingCartContent.itemsAdded) {
						if (this.paxDeletedFeatures[i].code == this.shoppingCartContent.itemsAdded[x].code &&
							this.paxDeletedFeatures[i].paxTatto == this.shoppingCartContent.itemsAdded[x].paxTatto) {
							deletedFeatures.push(this.shoppingCartContent.itemsAdded[x]);
						}
					}
				}

				/* if (addedAncillariesInCart.length != 0 && addedAncillaries.length == 0 && !deleteOnly) {
					for (const i in this.shoppingCartContent.itemsAdded) {
						const ancillaryType = addedAncillariesInCart[0].type;
						if (this.shoppingCartContent.itemsAdded[i].type == ancillaryType) {
							deletedFeatures.push(this.shoppingCartContent.itemsAdded[i]);
						}
					}
				} else {
					for (const i in this.shoppingCartContent.itemsAdded) {
						if (deletedFeaturesCode.includes(this.shoppingCartContent.itemsAdded[i].code)) {
							deletedFeatures.push(this.shoppingCartContent.itemsAdded[i]);
						}
					}
				} */

				// deletedFeatures = _.uniqBy(deletedFeatures, v => [v.code, v.paxTatto].join());
				this.paxDeletedFeatures = _.cloneDeep(deletedFeatures);

				this.ancillariesSelectionSrv.INDRA_addAncillariesSelectionItems(this.paxDeletedFeatures);
				this.ancillariesSelectionSrv.INDRA_doAncillariesDeletion(this.pnr).subscribe((data) => {
					if (data.errors.length === 0) {
						if (deleteOnly) {
							this.INDRA_handleAncillariesSelectionOk(addedAncillaries);
							this.hasAppliedToAllFlights = true;
							this.isServiceLoading = false;
							this.isLoaded.emit(true);
							this.paymentInfoService.setUpdateBookingTotals(true);
						} else {
							if (addedAncillaries.length != 0) {
								if (this.ancillariesType == EXTRAS_ANCILLARY_BAG) {
									addedAncillaries = addedAncillaries.filter(item => item.flightCardId == this.flightCardId);
								} else {
									addedAncillaries = _.uniqBy(addedAncillaries, v => [v.code, v.paxTatto].join());
								}
								this.INDRA_callApplyAllAPI(addedAncillaries);
							} else if (addedAncillariesInCart.length != 0) {
								if (this.ancillariesType == EXTRAS_ANCILLARY_BAG) {
									addedAncillaries = addedAncillaries.filter(item => item.flightCardId == this.flightCardId);
								} else {
									addedAncillaries = _.uniqBy(addedAncillaries, v => [v.code, v.paxTatto].join());
								}
								this.INDRA_callApplyAllAPI(addedAncillariesInCart);
							}
						}
					} else {
						this.INDRA_handleAncillariesDeletionError(data.errors[0].desc);
					}
				}, (error) => {
					this.INDRA_handleAncillariesDeletionError(error.details);
				});
			}
		}
	}

	INDRA_handleAncillariesSelection() {
		let addedAncillaries: INDRAAddOnAncillary[] = this.INDRA_getAllAddedAncillaries(false);

		if (JSON.stringify(addedAncillaries) === JSON.stringify(this.ancillaryOnOtherFlightCard)) {
			addedAncillaries = [];
		}

		this.INDRA_handleAggregateSales(addedAncillaries);
		if (addedAncillaries.length == 0 && this.paxDeletedFeatures.length == 0) {
			this.closeSidebar();
		} else {
			if (this.payWithMiles) {
				addedAncillaries.forEach(item => item.payWithMiles = true);
			}

			this.isServiceLoading = true;
			this.selectionApiError = false;
			this.INDRA_registerGAAddAncillaryToCart();
			this.ancillariesSelectionSrv.INDRA_addAncillariesSelectionItems(this.paxDeletedFeatures);
			this.ancillariesSelectionSrv.INDRA_doAncillariesDeletion(this.pnr)
				.subscribe((data) => {
					if (data.errors.length === 0) {
						this.ancillariesSelectionSrv.INDRA_addAncillariesSelectionItems(addedAncillaries);
						this.ancillariesSelectionSrv.INDRA_doAncillariesSelection(this.pnr, this.payWithMiles)
							.subscribe((data2) => {
								if (data2.errors.length === 0) {
									this.INDRA_assignTattoosToSelection(data2, addedAncillaries);
									this.INDRA_handleAncillariesSelectionOk(addedAncillaries);
									if ((addedAncillaries[0] && addedAncillaries[0].type === EXTRAS_ANCILLARY_SEAT) ||
										(this.paxDeletedFeatures[0] && this.paxDeletedFeatures[0].type === EXTRAS_ANCILLARY_SEAT)) {
										this.isLoaded.emit(true);
									}
									//CONDITION: REMOVE ANCILLARY - UPDATE tempShoppingCartContent DATA
									if (this.paxDeletedFeatures && this.paxDeletedFeatures.length > 0) {
										addedAncillaries = this.INDRA_getAllAddedAncillaries(true);
										let tempShoppingCartContent = _.cloneDeep(this.shoppingCartContent)

										if (tempShoppingCartContent && tempShoppingCartContent.itemsAdded.length > 0) {
											this.paxDeletedFeatures.forEach(data => {
												tempShoppingCartContent.itemsAdded.map(data2 => {
													if (data.ssrTatto == data2.ssrTatto) {
														tempShoppingCartContent.itemsAdded.pop();
													}
												});

											});
											addedAncillaries = tempShoppingCartContent.itemsAdded;
										}
									}

									//CHECKED IF THE PAYMENT MENTHOD HAS BEEN UPDATED
									//IF TRUE, IT WILL UPDATE ALL ANCILLARIES PAYMENT METHOD 
									if (this.paymentTypeChanged) {
										this.INDRA_handleUpdateAncPaymentType(addedAncillaries);

									} else {
										this.INDRA_updateMilesSpended(addedAncillaries);
										this.paymentInfoService.setUpdateBookingTotals(true);
										this.closeSidebar();
									}



								} else {
									this.INDRA_handleAncillariesSelectionError(data2.errors[0].desc);
									this.INDRA_handleAfterAncillariesSelectionKO();
								}
							}, (error) => {
								this.INDRA_handleAncillariesSelectionError(error.details);
								this.INDRA_handleAfterAncillariesSelectionKO();

							});
					} else {
						this.INDRA_handleAncillariesDeletionError(data.errors[0].desc);
					}
				}, (error) => {
					this.INDRA_handleAncillariesDeletionError(error.details);
				});
		}
	}

	private INDRA_handleAncillariesSelectionOk(addedAncillaries: INDRAAddOnAncillary[]) {
		if (this.paxDeletedFeatures.length > 0) {
			this.ancillariesShoppingCartSrv.INDRA_deleteAncillaries(this.paxDeletedFeatures);
		}

		if (addedAncillaries.length > 0) {
			this.ancillariesShoppingCartSrv.INDRA_addAncillaries(addedAncillaries);
		}
	}

	INDRA_handleAggregateSales(addedAncillaries: INDRAAddOnAncillary[]) {
		const addedAggregateSales = addedAncillaries.filter(anc => anc.aggregateSale && anc.aggregateSale.length > 0);
		addedAggregateSales.forEach(anc => {
			const aggregate = anc.aggregateSale.replace(anc.segmentId + '', '');
			const flightsToInclude = aggregate.split(',');
			for (let i = 0; i < flightsToInclude.length; i++) {
				if ((!flightsToInclude[i] || flightsToInclude[i].length === 0)) {
					continue;
				}

				if (anc.flightBasedAddOns && anc.flightBasedAddOns.some(el => el.segmentId == +flightsToInclude[i] &&
					this.bookingService.INDRA_getFlightIdBySegment(flightsToInclude[i]) == el.flightId)) {
					continue;
				}

				const flightBasedAddOn = _.cloneDeep(anc);
				flightBasedAddOn.price = 0;
				flightBasedAddOn.flightId = this.bookingService.INDRA_getFlightIdBySegment(flightsToInclude[i]);
				flightBasedAddOn.segmentId = flightsToInclude[i];
				flightBasedAddOn.itemId = flightBasedAddOn.itemId + 1;
				anc.flightBasedAddOns.push(flightBasedAddOn);

			}
		});

	}

	protected INDRA_handleSeatSelectionOk(addedAncillaries: INDRAAddOnAncillary[]) {
		this.paxAddedFeature = [];
		this.ancillariesShoppingCartSrv.INDRA_addSeats(addedAncillaries, this.paxDeletedFeatures);
	}

	protected INDRA_handleAfterAncillariesSelectionKO() { }

	private INDRA_handleAncillariesSelectionError(error: string = '') {
		this.selectionApiError = true;
		this.isServiceLoading = false;
		this.hasAppliedToAllFlights = false;
		this.isLoaded.emit(false);
		console.log(`[Error Ancillaries Selection]: ${error}`);
		// In case of error shopping cart is empty
		this.ancillariesShoppingCartSrv.INDRA_emptyAncillariesShoppingCart().subscribe(res => {
			this.paymentInfoService.setUpdateBookingTotals(true);
		}, err => {
			this.paymentInfoService.setUpdateBookingTotals(true);
		});
		this.paxDeletedFeatures = [];
		this.paxAddedFeature = [];
		this.totalAddedItems = 0;
		this.totalPrice = 0;
		this.totalCurrency = '';
	}

	private INDRA_handleAncillariesDeletionError(error: string) {
		this.selectionApiError = true;
		this.isServiceLoading = false;
		this.hasAppliedToAllFlights = false;
		this.isLoaded.emit(false);
		console.log('[Error Ancillaries Deletion]:' + error);
		// In case of error shopping cart is empty
		this.ancillariesShoppingCartSrv.INDRA_emptyAncillariesShoppingCart().subscribe(res => {
			this.paymentInfoService.setUpdateBookingTotals(true);
		}, err => {
			this.paymentInfoService.setUpdateBookingTotals(true);
		});
		this.paxDeletedFeatures = [];
		this.paxAddedFeature = [];
		this.totalAddedItems = 0;
		this.totalPrice = 0;
		this.totalCurrency = '';
	}
	private INDRA_handleAncillariesUpdatePaymentTypeError(error: string) {
		this.paymentInfoService.setUpdateBookingTotals(true);
		this.selectionApiError = true;
		this.isServiceLoading = false;
		this.isLoaded.emit(false);
		console.log('[Error Ancillaries Payment Type update]:' + error);

		// return payWithMiles to previous status
		for (const i in this.shoppingCartContent.itemsAdded) {
			if (this.shoppingCartContent.itemsAdded[i].type === this.ancillariesType) {
				this.shoppingCartContent.itemsAdded[i].payWithMiles = !this.payWithMiles;
			}
		}
		this.payWithMiles = !this.payWithMiles;
		this.storageService.set('INDRAAncillariesShoppingCartService.shoppingCart', this.shoppingCartContent);
	}

	private INDRA_assignTattoosToSelection(data: INDRAAncillariesSelectionConfirmation, addedAncillaries: INDRAAddOnAncillary[]) {
		addedAncillaries.forEach(addOn => {
			addOn.ssrTatto = '-1';
			if (addOn.flightBasedAddOns) {
				addOn.flightBasedAddOns.forEach(fbAddOn => {
					fbAddOn.ssrTatto = '-1';
				});
			}
		});

		data.selectedAncillaries.forEach(selection => {
			selection.journey.forEach(journey => {
				journey.passengers.forEach(passenger => {

					passenger.ancillaryInfo.forEach(ancillaryInfo => {
						const machedAncillariesCodes = addedAncillaries.filter(addOn => addOn.flightId == journey.flightId && addOn.segmentId == journey.segmentId
							&& addOn.code === ancillaryInfo.code && addOn.paxId == Number(passenger.paxId));
						machedAncillariesCodes.forEach(addOn => {
							addOn.ssrTatto = ancillaryInfo.ssrTatto;
						});

						const flightBasedAddOns = addedAncillaries.filter(addOn => addOn.flightBased === true);
						flightBasedAddOns.forEach(fbAddOn => {
							if (fbAddOn.flightBasedAddOns) {
								const fbMachedAncillariesCodes = fbAddOn.flightBasedAddOns.filter(addOn => addOn.flightId == journey.flightId && addOn.segmentId == journey.segmentId
									&& addOn.code === ancillaryInfo.code && addOn.paxId == Number(passenger.paxId));
								fbMachedAncillariesCodes.forEach(addOn => {
									addOn.ssrTatto = ancillaryInfo.ssrTatto;
								});
							}
						});
					});
				});
			});
		});

	}

	// OTHER REUSABLE METHODS

	INDRA_capitalize(str: string) {
		if (str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_printPassengerName(pax: INDRAPax) {
		if (this.isReviewFlights && PAX_TYPES.includes(pax.typePax)) {
			const key = 'addMoreSidebars.passenger.label.' + pax.typePax;
			return this.INDRA_getTranslation(key) + ' ' + this.INDRA_capitalize(pax.surname);
		} else {
			return this.INDRA_capitalize(pax.name) + ' ' + this.INDRA_capitalize(pax.surname);
		}
	}


	/**
	 * Return the number of added items in this sidebar
	 */
	INDRA_printItemsCount(): number {
		return this.totalAddedItems;
	}

  INDRA_printItemsCountPerSegment(segmentId): number {
    let addedAnc = this.INDRA_getAllAddedAncillaries(true);
    return addedAnc.filter(item => item.segmentId == segmentId).length
  }

	/**
	 * @returns print-ready string of value of added ancillaries
	 */
	INDRA_printTotal(): string {
		return parseFloat(this.totalPrice.toString()).toFixed(2) + this.totalCurrency;
	}

	INDRA_printTotalPerSegment(segmentId): string {
		let addedAnc = this.INDRA_getAllAddedAncillaries(true);
		let totalPricePerSegment = 0;
		if (addedAnc && addedAnc.length > 0) {
			addedAnc.map(anc => {
				if (anc.segmentId == segmentId) {
					totalPricePerSegment += Number(anc.price);
				}
			})
		}

		if(totalPricePerSegment && totalPricePerSegment > 0){
			return parseFloat(totalPricePerSegment.toString()).toFixed(2) + this.totalCurrency;
		}else{
			return null;
		}
	}

	INDRA_getCurrencySymbol(code: string): string {
		// const returnValue = getCurrencySymbol(code, 'narrow');
		const returnValue = code;
		return returnValue;
	}

	INDRA_formatCashPrice(price) {
		return (+price).toLocaleString(sessionStorage.getItem(SESSION_VAR_KEY_MARKET), { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}

	INDRA_getBoundType() {
		const boundType = this.bookingService.INDRA_getFlightBoundType(this.flight.idFlight);
		return boundType === 'inbound' ? this.INDRA_getTranslation('addMoreSidebars.general.titles.inbound') :
			this.INDRA_getTranslation('addMoreSidebars.general.titles.outbound');
	}

	INDRA_getDepartureCityForStopoverNotification() {
		return this.bookingService.INDRA_getLocation(this.flightRouteInput.listSegment[0].departureAirport).city;
	}

	INDRA_getArrivalCityForStopoverNotification() {
		const lastSegmentIndex = this.flightRouteInput.listSegment.length - 1;
		return this.bookingService.INDRA_getLocation(this.flightRouteInput.listSegment[lastSegmentIndex].arrivalAirport).city;
	}

	INDRA_getOperationErrorNotificationTitle() {
		return this.INDRA_getTranslation('addMoreSidebars.general.titles.operationError');
	}

	INDRA_mapAncillaryOptions(ancillaries: INDRAAddOnAncillary[], ancillaryDetailedKey: string, isPets = false) {
		const replaceUndefined = (key, value) => typeof value === 'undefined' ? null : value;
		return ancillaries.map(ancillary => ({
			value: this.ancillariesType == EXTRAS_ANCILLARY_MEAL ? ancillary : JSON.stringify(ancillary, replaceUndefined),
			text: this.INDRA_getTranslation(isPets ? (ancillaryDetailedKey + ancillary.code + ancillary.value) : (ancillaryDetailedKey + ancillary.code)) + ' (' + this.currencyPipe.transform((ancillary.price)) + this.INDRA_getCurrencySymbol(ancillary.currency) + ')'
		}));
	}

	INDRA_hasNextOrPreviousFlight() {
		return this.bookingService.INDRA_hasNextFlight(this.flightCardId)
			|| this.bookingService.INDRA_hasPreviousFlight(this.flightCardId);
	}

	INDRA_addAncillariesToOtherFlights(data, addedAncillaries) {
		const ancillariesList = [];
		const flightInfo = data.selectedAncillaries[0].journey;
		let found = false;
		let ancillaryPrice = 0;
		let flightId = 0;
		let segmentId = 0;
		let currentPassenger = 0;

		for (const i in addedAncillaries) {
			for (const x in flightInfo) {
				if ((addedAncillaries[i].flightId.toString() != flightInfo[x].flightId) || (addedAncillaries[i].flightId.toString() == flightInfo[x].flightId && addedAncillaries[i].segmentId.toString() != flightInfo[x].segmentId)) {
					const passengerList = flightInfo[x].passengers;
					for (const z in passengerList) {
						// tslint:disable-next-line:radix
						if (addedAncillaries[i].paxId == parseInt(passengerList[z].paxId)) {

							currentPassenger = +passengerList[z].paxId;

							const passengerAncillaries = _.cloneDeep(passengerList[z].ancillaryInfo);
							for (const n in passengerAncillaries) {
								// if (passengerAncillaries[n].code == addedAncillaries[i].code && (passengerAncillaries[n].price != 0 || this.ancillariesType == EXTRAS_ANCILLARY_MEAL)) {
								if (passengerAncillaries[n] && passengerAncillaries[n]['price'] != 0 && passengerAncillaries[n].code === addedAncillaries[i].code || this.ancillariesType == EXTRAS_ANCILLARY_MEAL) {
									// tslint:disable-next-line:radix

									ancillaryPrice = passengerAncillaries[n].price.toFixed(2);
									found = true;
									break;
								}
							}
						}
						if (found) {
							break;
						}
					}
				}
				if (found) {
					// tslint:disable-next-line:radix
					flightId = parseInt(flightInfo[x].flightId);
					// tslint:disable-next-line:radix
					segmentId = parseInt(flightInfo[x].segmentId);

					const ancillaryToAdd = _.cloneDeep(addedAncillaries[i]);
					ancillaryToAdd.flightId = flightId;
					ancillaryToAdd.segmentId = segmentId;
					ancillaryToAdd.price = ancillaryPrice;
					const tempFlightCardId = this.INDRA_getFlightCardId(flightId, segmentId);
					if (tempFlightCardId) {
						ancillaryToAdd.flightCardId = tempFlightCardId.toString();
						if (this.INDRA_checkAncillaryAvailability(ancillaryToAdd)) {

							const hasAdded = ancillariesList.find(item => item.flightId == ancillaryToAdd.flightId && item.paxId == ancillaryToAdd.paxId);
							if (!ancillaryToAdd.flightBased && !hasAdded) {
								ancillariesList.push(ancillaryToAdd);
							} else if (ancillaryToAdd.flightBased) {
								ancillariesList.push(ancillaryToAdd);
							}
						}
					}
					found = false;
				}
			}
		}

		return ancillariesList;
	}

	INDRA_getDeletedFeaturesCode() {
		const deletedFeaturesList = [];
		for (const i in this.paxDeletedFeatures) {
			if (!(deletedFeaturesList.includes(this.paxDeletedFeatures[i].code))) {
				deletedFeaturesList.push(this.paxDeletedFeatures[i].code);
			}
		}

		return deletedFeaturesList;
	}

	INDRA_callApplyAllAPI(addedAncillaries: any) {
		addedAncillaries.forEach(anc => {
			anc.spendPoints = this.payWithMiles;
		});

		this.ancillariesSelectionSrv.INDRA_applyAncillariesToOtherFlights(addedAncillaries, this.pnr).subscribe((data) => {
			if (data.status == '200') {
				if (data.errors.length === 0 && (data.applyAllFlightsProcessed == true || !data.hasOwnProperty('applyAllFlightsProcessed'))) {
					const ancillariesList = this.INDRA_addAncillariesToOtherFlights(data, addedAncillaries);

					if (ancillariesList.length != 0) {
						addedAncillaries = addedAncillaries.concat(ancillariesList);
					}
					this.ancillariesSelectionSrv.INDRA_addAncillariesSelectionItems(addedAncillaries);
					this.INDRA_assignTattoosToSelection(data, addedAncillaries);
					this.INDRA_handleAncillariesSelectionOk(addedAncillaries);

					this.ancillariesSelectionSrv.INDRA_clearAncById();
					this.hasAppliedToAllFlights = true;
					this.isServiceLoading = false;
					this.isLoaded.emit(true);
					// this.closeSidebar();

					// check paxAddedFeature for ancillaries added
					// to other segments after applyAll
					this.paxAddedFeature.forEach(arr => {
						let paxAddedFeatureSpliced = [];
						arr[Object.keys(arr)[0]].forEach((a, index) => {
							if (a['ssrTatto']) {
								paxAddedFeatureSpliced.push(a);
							}
						});
						arr[Object.keys(arr)[0]] = paxAddedFeatureSpliced;
					});

					this.paymentInfoService.setUpdateBookingTotals(true);

				} else {
					if (data.errors.length > 0 && data.errors[0].desc) {
						this.INDRA_handleAncillariesSelectionError(data.errors[0].desc);
					}
					else {
						this.INDRA_handleAncillariesSelectionError('Apply all flights not processed');
					}
					this.INDRA_handleAfterAncillariesSelectionKO();
				}
			}
		}, (error) => {
			this.INDRA_handleAncillariesSelectionError(error.details);
			this.INDRA_handleAfterAncillariesSelectionKO();
		});
	}

	INDRA_ancillariesChanged() {
		const addedAncillaries: INDRAAddOnAncillary[] = this.INDRA_getAllAddedAncillaries(false);
		// let addedAncillaries: INDRAAddOnAncillary[];

		// if (this.paxDeletedFeatures && this.paxDeletedFeatures.length > 0) {
		// 	addedAncillaries = this.INDRA_getAllAddedAncillaries(true);
		// } else {
		// 	addedAncillaries = this.INDRA_getAllAddedAncillaries(false);
		// }

		if (addedAncillaries.length == 0 && this.paxDeletedFeatures.length == 0) {
			return false;
		}
		return true;
	}

	INDRA_handleProcessAncillaries(ancillaryType, addedAncillary, milesNeeded, bookedTrip) {
		//VALIDATION: CHECK THE "PAY WITH MILES" STATUS OF THE SELECTED FLIGHT CARD, THEN SET IT AS THE GLOBAL "this.payWithMiles" VALUE 
		this.payWithMiles = this.ancillariesSelectionSrv.INDRA_getFlightPayWithMilesStatus(this.flightCardId, ancillaryType);
		sessionStorage.removeItem("is"+ancillaryType+"withMiles");

		if (this.isUserLoggedIn && this.bookAwardFlights && this.payWithMiles) {
			let bookingTotalMiles = bookedTrip ? bookedTrip.data.fare.bookingTotal.miles : 0; //TOTAL MILES COST FROM FLIGHT
			let addedAncMiles: number = milesNeeded ? milesNeeded : 0; //TOTAL MILES COST FROM ADDED ANCILLARIES 
			let totalMilesToPay = this.storageService.get('tempTotalMilesToPay') ? this.storageService.get('tempTotalMilesToPay') : 0;
			let limitNegativeMiles: number;
			switch (this.userTierLevel) {
				case TAP_HEADER_MILES_AND_GO_MILES:
					limitNegativeMiles = this.limitNegativeFFLevelMiles;
					break;
				case TAP_HEADER_MILES_AND_GO_SILVER:
					limitNegativeMiles = this.limitNegativeFFLevelSilver;
					break;
				case TAP_HEADER_MILES_AND_GO_GOLD:
					limitNegativeMiles = this.limitNegativeFFLevelGold;
					break;
				case TAP_HEADER_MILES_AND_GO_NAVIGATOR:
					limitNegativeMiles = this.limitNegativeFFLevelNavigator;
					break;
				default:
					limitNegativeMiles = 0;
			}

			this.tempShoppingCartContent = _.cloneDeep(this.shoppingCartContent);
			if (this.tempShoppingCartContent && this.tempShoppingCartContent.itemsAdded.length > 0) {
				let milesNeededShopCart: number = 0;
				let selectedStoredAncMilesNeeded: number = 0;
				this.tempShoppingCartContent.itemsAdded.map(data => {
					if (data.payWithMiles && data.flightCardId == this.flightCardId && data.type == ancillaryType) {
						selectedStoredAncMilesNeeded += data.points;
					}

					if (data.payWithMiles) {
						milesNeededShopCart += data.points;
					}
				});

				addedAncMiles = milesNeededShopCart + (Math.abs(milesNeeded - selectedStoredAncMilesNeeded));
				totalMilesToPay = (bookingTotalMiles + addedAncMiles);
			}
			else {
				if (totalMilesToPay > 0) {
					totalMilesToPay += addedAncMiles;
				} else {
					totalMilesToPay = bookingTotalMiles + addedAncMiles;
				}
			}

			let userMilesWithLimitNegativeMiles = this.userMiles + limitNegativeMiles;

			//VALIDATION: UNCHECK THE CHECKBOX WHEN USER REMOVES ALL THE SELECTED ANCILLARY WHILE THE "PAY WITH MILES" IS CHECKED 
			if (milesNeeded <= 0) {
				this.payWithMiles = false;
				this.ancillariesSelectionSrv.INDRA_getPayWithMilesByFlightId(this.flightCardId, false, ancillaryType);
			}

			if (totalMilesToPay <= userMilesWithLimitNegativeMiles) {
				//VALIDATION: HAS ENOUGH MILES, PROCESS REQUEST
				this.storageService.set('tempTotalMilesToPay', totalMilesToPay);
				this.INDRA_validateProcessAncillary(ancillaryType, this.flightCardId);

				this.isBtnDoneClicked = true;
				return false;
			} else {

				if (!this.closeSideBarFlag) {
					if (this.payWithMiles) {
						this.closeSideBarFlag = true;
						return true;
					} else {
						this.INDRA_validateProcessAncillary(ancillaryType, this.flightCardId);
						this.isBtnDoneClicked = true;
						return false;
					}
				} else {
					this.sidebarService.closeSidebar();
					this.closeSideBarFlag = false;
				}
				this.INDRA_registerGAAddAncillaryToCart();
				this.INDRA_updateMilesSpended();
				this.ancillariesSelectionSrv.INDRA_getPayWithMilesByFlightId(this.flightCardId, false, ancillaryType);

				return true;
			}
		} else {
			//VALIDATION: HAS ENOUGH MILES, PROCESS REQUEST
			this.INDRA_validateProcessAncillary(ancillaryType, this.flightCardId);
			this.isBtnDoneClicked = true;
			return false;
		}

	}

	INDRA_validateProcessAncillary(ancillaryType, flightCardId) {
		if (this.shoppingCartContent) {
			if (this.shoppingCartContent.itemsAdded.length != 0) {
				for (const i in this.shoppingCartContent.itemsAdded) {
					if (this.shoppingCartContent.itemsAdded[i].type == ancillaryType && this.shoppingCartContent.itemsAdded[i].flightCardId == flightCardId) {
						if (this.shoppingCartContent.itemsAdded[i].payWithMiles != this.payWithMiles) {
							this.shoppingCartContent.itemsAdded[i].payWithMiles = this.payWithMiles; // fix different bound different payment method but same ancillary type
							//TRIGGER PAYMENT CHANGE WHENEVER WE DETECTED THAT PART OF THE SHOPPING CART ITEMS HAS BEEN CHANGED 
							this.paymentTypeChanged = true;
						}
					}
				}
				this.storageService.set('INDRAAncillariesShoppingCartService.shoppingCart', this.shoppingCartContent);
				this.tempShoppingCartContent = this.shoppingCartContent;
			}
		}

		if (this.paymentTypeChanged) {
			this.ancillaryToUpdate = this.shoppingCartContent.itemsAdded.filter(item => {
				if (item.type === ancillaryType && item.flightCardId == flightCardId) return item;
			});
		}


		if (this.INDRA_ancillariesChanged()) {
			this.INDRA_handleDone();
		} else if (this.paymentTypeChanged) {
			this.INDRA_handleUpdateAncPaymentType();
		} else {
			this.INDRA_registerGAAddAncillaryToCart();
			this.INDRA_updateMilesSpended();
			this.sidebarService.closeSidebar();
		}
	}


	INDRA_payAncillaryWithMiles(event) {
		const prevPayWithMilesVal = this.payWithMiles;
		this.payWithMiles = event;

		if (prevPayWithMilesVal !== this.payWithMiles) {
			this.paymentTypeChanged = true;
		}
	}

	INDRA_updateMilesSpended(addedAncillaries?) {
		let milesNeeded = 0;

		const itemsAdded = this.shoppingCartContent.itemsAdded;
		if (itemsAdded && itemsAdded.length) {
			for (const i in itemsAdded) {
				if (itemsAdded[i].payWithMiles) {
					// if (itemsAdded[i].payWithMiles && itemsAdded[i].flightCardId == this.flightCardId) {
					milesNeeded = milesNeeded + itemsAdded[i].points;
				}
			}
		}

		const totalMiles = (this.milesSpent - this.ancillariesTotalDiscount) + milesNeeded;
		const bookingTotalMiles = this.storageService.get('INDRABFMDataStorageService._activeBooking')

		//UPDATE THE STORED VALUE FOR "tempTotalMilesToPay" EVERY AFTER ADDING/DELETING OF ANCILLARY
		this.storageService.set('tempTotalMilesToPay', totalMiles + bookingTotalMiles.data.fare.bookingTotal.miles);

		this.store.dispatch(new AncillariesWithMilesActions.PutProcessAncillary(totalMiles));
		// this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction(totalMiles));
	}

	INDRA_checkOtherFlightAncillaries() {
		for (const i in this.flightAncillaryDetails) {
			if (this.flightAncillaryDetails[i].flightDetails) {
				if (!(this.flight.assignedFlightId == this.flightAncillaryDetails[i].flightDetails.assignedFlightId &&
					this.flight.idFlight == this.flightAncillaryDetails[i].flightDetails.idFlight &&
					this.flight.idFlightAvail == this.flightAncillaryDetails[i].flightDetails.idFlightAvail)) {
					if (this.flightAncillaryDetails[i].includedAncillaries.includes(this.ancillariesType)) {
						return true;
					}
				}
			}
		}

		return false;
	}

	INDRA_getFlightCardId(flightId, segmentId) {
		let flightCard: any;
		let found = false;
		let nextFlightIdentifier: any = this.flightCardId;
		let previousFlightIdentifier: any = this.flightCardId;
		do {
			nextFlightIdentifier = this.bookingService.INDRA_getNextFlightCardId(nextFlightIdentifier.toString());
			if (nextFlightIdentifier > 0) {
				const flightInfo = this.bookingService.INDRA_getBookedFlight(nextFlightIdentifier.toString());
				if (flightInfo.idFlight == flightId) {
					for (const i in flightInfo.listSegment) {
						if (flightInfo.listSegment[i].idInfoSegment == segmentId) {
							flightCard = nextFlightIdentifier;
							found = true;
						}
					}
				}
			}
		} while (!found && nextFlightIdentifier > 0);

		if (!found) {
			do {
				previousFlightIdentifier = this.bookingService.INDRA_getPreviousFlightCardId(previousFlightIdentifier.toString());
				if (previousFlightIdentifier > 0) {
					const flightInfo = this.bookingService.INDRA_getBookedFlight(previousFlightIdentifier.toString());
					if (flightInfo.idFlight == flightId) {
						for (const i in flightInfo.listSegment) {
							if (flightInfo.listSegment[i].idInfoSegment == segmentId) {
								flightCard = previousFlightIdentifier;
								found = true;
							}
						}
					}
				}
			} while (!found && previousFlightIdentifier > 0);
		}
		return flightCard;
	}

	INDRA_checkAncillaryAvailability(ancillaryToAdd) {
		const otherFlight = this.bookingService.INDRA_getBookedFlight(ancillaryToAdd.flightCardId);
		for (const i in this.flightAncillaryDetails) {
			if (this.flightAncillaryDetails[i].flightDetails) {
				if (otherFlight.assignedFlightId == this.flightAncillaryDetails[i].flightDetails.assignedFlightId &&
					otherFlight.idFlight == this.flightAncillaryDetails[i].flightDetails.idFlight &&
					otherFlight.idFlightAvail == this.flightAncillaryDetails[i].flightDetails.idFlightAvail) {
					if (this.flightAncillaryDetails[i].includedAncillaries.includes(this.ancillariesType)) {
						return true;
					}
				}
			}
		}

		return false;
	}

	INDRA_registerGAAddAncillaryToCart() {
		const addedAncillaries: INDRAAddOnAncillary[] = this.INDRA_getAllAddedAncillaries(false);
		if (addedAncillaries.length) {
			let shoppingCart = this.shoppingCartContent && this.shoppingCartContent.itemsAdded.length ? this.shoppingCartContent.itemsAdded : [];
			shoppingCart = shoppingCart.concat(addedAncillaries);
			const ancillaries = this.googleAnalytics.IBE_groupAncillaries({ itemsAdded: _.cloneDeep(shoppingCart) });
			const eventDataLayerObject = this.googleAnalytics.IBE_createGA_AncillariesProducts(ancillaries);
			eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_ADD_CART);
			this.googleAnalytics.INDRA_GA_addToCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
		}
	}

	INDRA_registerGARemoveAncillaryFromCart(ancillary) {
		if (this.shoppingCartContent && this.shoppingCartContent.itemsAdded.length && this.shoppingCartContent.itemsAdded.find(item => item.code === ancillary.code)) {
			const ancillaries = this.googleAnalytics.IBE_groupAncillaries({ itemsAdded: [ancillary] });
			const eventDataLayerObject = this.googleAnalytics.IBE_createGA_AncillariesProducts(ancillaries);
			this.googleAnalytics.INDRA_GA_removeFromCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
		}
	}

	INDRA_isPayWithMiles() {
		const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
		const ancillary = shoppingCartItems.itemsAdded.find(item => item.type == this.ancillariesType);
		if (ancillary) {
			return ancillary.payWithMiles;
		}

		return false;
	}

	INDRA_getInputOptions(isPets = false) {
		if (this.passengers.length > 0) {
			this.optionList = [];
			this.passengers.forEach(passenger => {
				this.optionList.push(
					this.INDRA_mapAncillaryOptions(this.INDRA_getAddOnForPassenger(passenger.idPax), this.translationAncillaryDetailedKey, isPets)
				);
			});
		}
	}

	INDRA_handleUpdateAncPaymentType(addedAncillaries?) {
		//USE INCOMING addedAncillaries DATA IF THERE HAS BEEN DELETION OR THE ancillaryToUpdate IS EMPTY 
		if (this.paxDeletedFeatures.length > 0 || this.ancillaryToUpdate.length <= 0) {
			this.ancillaryToUpdate = addedAncillaries;
		}
		this.paymentTypeChanged = false;
		this.isServiceLoading = true;

		this.ancillariesSelectionSrv.INDRA_addAncillariesSelectionItems(this.ancillaryToUpdate);
		this.ancillariesSelectionSrv.INDRA_updateAncillariesPaymentType(this.pnr, this.payWithMiles).subscribe(res => {
			if (res.status === '200') {
				this.isServiceLoading = false;
				if (addedAncillaries) {
					this.INDRA_updateMilesSpended(addedAncillaries);
				} else {
					this.INDRA_updateMilesSpended();
				}
				this.paymentInfoService.setUpdateBookingTotals(true);
				this.sidebarService.closeSidebar();
			} else {
				this.INDRA_handleAncillariesUpdatePaymentTypeError(res.errors && res.errors.length > 0 ? res.errors[0].desc : null);
			}
		}, (error) => {
			this.INDRA_handleAncillariesUpdatePaymentTypeError(error.details);
		});
	}

	INDRA_closeSidebar() {
		this.sidebarService.closeSidebar();
	}
}

